<template>
    <form>
        <div class="row">
            <div class="form-group col-md-12">
                <div class="col-xs-9">
                    <div style="border: 1px solid #e5e5e5; height: 300px; overflow: auto; padding: 10px;">
                        <span v-html="result.texto"></span>
                    </div>
                </div>
            </div>
        </div>
        <button type="button" class="btn btn-outline-secondary" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button v-if="!pessoaProduto.temAceiteRegulamento" type="button" class="btn btn-success float-right" @click="confirmRegulamento()">
            <span>Aceitar</span>
        </button>
    </form>
</template>
<script>
    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: 'regulamento',
        components: {},
        mixins: [base],
        props: { Id: Number, pessoaProduto: Object },
        data() {
            return {
                resources: {
                },
                result: {},
            }
        },
        methods: {
            getRegulamento: function () {
                new Api("regulamento")
                    .get({
                        id: this.pessoaProduto.produto.regulamentoId
                    })
                    .then(data => {
                        this.result = data.data;
                    }, err => {
                        this.defaultErrorResult(err);
                    })
            },
            confirmRegulamento() {
                new Api("pessoaprodutoregulamento")
                    .post({
                        regulamentoId: this.pessoaProduto.produto.regulamentoId,
                        pessoaProdutoId: this.pessoaProduto.pessoaProdutoId
                    })
                    .then(data => {
                        this.defaultSuccessResult("Regulamento aceito com sucesso.");
                        this.pessoaProduto.temAceiteRegulamento = true;
                        this.$emit('on-saved');
                    }, err => {
                        this.defaultErrorResult(err);
                    })
            },
            onBack: function () {
                this.$emit('on-back')
            }
        },
        mounted() {
            this.getRegulamento();
        }
    };
</script>
